let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8eKQI")).then(() => parcelRequire('brcIJ'));